export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getVariation.js
// module id = ./node_modules/@popperjs/core/lib/utils/getVariation.js
// module chunks = 1